<div class="component-holder px-0" *ngIf="component.data$ | async as data">
  <img [pyMedia]="data?.media" />
</div>
